import React from "react";
import { Settings, User } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useNavigate, useLocation } from "react-router-dom";

const AccountProfile = () => {
  const profile = useSelector((state: RootState) => state.merchant?.profile);

  const navigate = useNavigate();
  const location = useLocation();

  // Check if current URL contains "admin"
  const isAdminRoute = location.pathname.includes("admin");

  const handleNavigate = () => {
    navigate("/dashboard/settings");
  };

  return (
    <div className="p-4 border-b border-gray-200 bg-white">
      <div className="flex items-start">
        <div className="h-10 w-10 rounded-full  flex items-center justify-center mr-3 mt-0.5">
          <User size={18} className="text-black" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-800 break-words leading-tight">
            {profile?.firstName}
          </p>
          <p className="text-xs text-gray-500 break-words leading-tight">
            {profile?.username}
          </p>
        </div>
        {!isAdminRoute && (
          <button
            className="p-2 rounded-full text-gray-500 hover:bg-gray-200 transition-colors ml-2 mt-0.5"
            onClick={handleNavigate}
          >
            <Settings size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default AccountProfile;
